<template>
  <router-link
    v-if="item.title !== 'Logout'"
    class="relative mr-4 inline-block text-xs text-light-gray"
    :to="`${item.href}`"
  >
    {{ item.title }}
    <span
      v-if="item.badge"
      class="absolute right-0 top-1 inline-block h-2 w-2 -translate-y-1/2 translate-x-1/2 transform rounded-full bg-badge-yellow"
    />
  </router-link>
</template>
<script>
export default {
  name: 'LinkBadge',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
